import {
  FiYoutube,
  FiLinkedin,
  FiInstagram,
  FiTwitter,
  FiPhone,
  FiMail,
} from "react-icons/fi";
import { RiTwitterXFill } from "react-icons/ri";

export default function Footer() {
  return (
    <div>
      <div className="main-footer">
        <div className="container">
          <div className="row">
            <div className="row">
              <div className="col-12 col-md-5">
                <p>© 2025 RegMatrix Pharmaceuticals Pvt. Ltd. All Rights Reserved. </p>
              </div>
              <div className="col-12 col-md-7 d-flex justify-content-end align-items-center">
                <ul className="top-link">
                  <li>
                    <a
                      href="mailto:contact@regmatrixpharma.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FiMail /> &nbsp; <span>contact@regmatrixpharma.com</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="mailto:regmatrixpharma@gmail.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FiMail /> &nbsp; <span>regmatrixpharma@gmail.com</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/regmatrixpharma"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FiLinkedin />
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://www.youtube.com/@RegMatrixPharma"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FiYoutube />
                    </a>
                  </li>
                  {/* <li>
                    <a
                      href="https://www.instagram.com/szreg_pharma/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FiInstagram />
                    </a>
                  </li> */}
                  <li>
                    <a
                      href="https://x.com/RegMatrixPharma"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <RiTwitterXFill />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
